import { useQuery } from '@tanstack/react-query';
import { fetchLocalRegions } from './fetchLocalRegions';
import { AgeCategory } from '../../../../../models/AgeCategory';

const LOCAL_REGIONS_QUERY_KEY = 'localRegions';
export const useLocalRegions = (ageCategory: AgeCategory) => {
    const { data, ...rest } = useQuery([LOCAL_REGIONS_QUERY_KEY, ageCategory], () => fetchLocalRegions(ageCategory));

    return {
        ...rest,
        localRegions: data?.level1 ?? []
    };
};
